import axios from "axios";

/** Resolve `/uploads/...` paths against the API origin (uploads are served by the backend). */
export function resolveUploadUrl(relativeUrl) {
  if (!relativeUrl) return "";
  const s = String(relativeUrl);
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.startsWith("/") ? s : `/${s}`;
  const base = (axios.defaults.baseURL || process.env.REACT_APP_API_URL || "")
    .replace(/\/$/, "");
  if (base) return `${base}${path}`;
  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }
  return path;
}
